import React from 'react';
import { Button } from '../ui/button';
import {
  FilePdf,
  FileXls,
  EnvelopeSimple,
  ShieldCheck,
  CheckCircle,
  Eye,
} from '@phosphor-icons/react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function CommunicationCard({ item, actionLoading, onPreview, onConfirm }) {
  const code = item.province;
  const isTestSent = item.has_test_sent;

  return (
    <div className="bg-white border border-slate-200 rounded-sm p-6" data-testid={`pending-${code}`}>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-4">
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-2">
              <h3 className="text-lg font-bold text-slate-900">Provincia: {code}</h3>
              {isTestSent && (
                <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-sm text-xs font-medium bg-blue-100 text-blue-800">
                  <EnvelopeSimple size={14} /> Test inviato
                </span>
              )}
              {item.has_documents && (
                <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-sm text-xs font-medium bg-green-100 text-green-800">
                  <CheckCircle size={14} /> Documenti pronti
                </span>
              )}
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
              <div>
                <p className="text-xs text-slate-500">POD attivi</p>
                <p className="font-semibold text-slate-900">{item.pod_count}</p>
              </div>
              <div>
                <p className="text-xs text-slate-500">Accise annue</p>
                <p className="font-semibold text-slate-900">
                  EUR {(item.total_excise || 0).toLocaleString('it-IT', { minimumFractionDigits: 2 })}
                </p>
              </div>
              <div>
                <p className="text-xs text-slate-500">UADM</p>
                <p className="font-semibold text-slate-900 text-xs">{item.customs_office}</p>
              </div>
              <div>
                <p className="text-xs text-slate-500">PEC Destinatario</p>
                <p className="font-semibold text-slate-900 text-xs break-all">{item.customs_pec}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap gap-2 pt-2 border-t border-slate-100">
          <Button size="sm" variant="outline" onClick={() => onPreview(code)}
            className="rounded-sm text-xs" data-testid={`preview-pdf-${code}`} disabled={!item.has_documents}>
            <Eye size={14} className="mr-1.5 text-slate-600" /> Anteprima
          </Button>
          <Button size="sm" variant="outline"
            onClick={() => window.open(`${API_URL}/api/communications/${code}/download-pdf`, '_blank')}
            className="rounded-sm text-xs" data-testid={`view-pdf-${code}`} disabled={!item.has_documents}>
            <FilePdf size={14} className="mr-1.5 text-red-600" /> PDF
          </Button>
          <Button size="sm" variant="outline"
            onClick={() => window.open(`${API_URL}/api/communications/${code}/download-excel`, '_blank')}
            className="rounded-sm text-xs" data-testid={`view-excel-${code}`} disabled={!item.has_documents}>
            <FileXls size={14} className="mr-1.5 text-green-600" /> Excel
          </Button>

          <div className="w-px h-6 bg-slate-200 self-center mx-1"></div>

          <Button size="sm" variant="outline"
            onClick={() => onConfirm('test', code, item.customs_office, item.customs_pec)}
            disabled={actionLoading[code + '_test'] || !item.has_documents}
            className="rounded-sm text-xs border-blue-200 text-blue-700 hover:bg-blue-50"
            data-testid={`send-test-${code}`}>
            <EnvelopeSimple size={14} className="mr-1.5" />
            {actionLoading[code + '_test'] ? 'Invio...' : 'Invio Mail Test'}
          </Button>

          <Button size="sm" variant="outline"
            onClick={() => onConfirm('pec_test', code, item.customs_office, item.customs_pec)}
            disabled={actionLoading[code + '_pectest'] || !item.has_documents}
            className="rounded-sm text-xs border-amber-200 text-amber-700 hover:bg-amber-50"
            data-testid={`send-pec-test-${code}`}>
            <ShieldCheck size={14} className="mr-1.5" />
            {actionLoading[code + '_pectest'] ? 'Invio...' : 'PEC Prova'}
          </Button>

          <Button size="sm"
            onClick={() => onConfirm('pec', code, item.customs_office, item.customs_pec)}
            disabled={actionLoading[code + '_pec'] || !item.has_documents}
            className="bg-green-600 hover:bg-green-700 text-white rounded-sm text-xs"
            data-testid={`send-pec-${code}`}>
            <ShieldCheck size={14} className="mr-1.5" />
            {actionLoading[code + '_pec'] ? 'Invio...' : 'Invio PEC Definitiva'}
          </Button>
        </div>
      </div>
    </div>
  );
}
